import { FC, useEffect, useState } from "react";
import styles from './showroomComponent.module.scss';
import { useNavigate } from "react-router-dom";
import { useGlobalState } from "../../../../../../../../context/context";
import { useUser } from "../../../../../../../../hooks/useUser";
import Can from "../../../../../../../../components/auth/Can";
import {
    Button,
    Card,
    Menu,
    MenuItem,
    Stack,
    Typography,
    Box
} from "@mui/material";
import {
    SettingsRounded,
    DashboardRounded,
    ReceiptLongRounded,
    LogoutRounded,
    AdminPanelSettingsRounded,
    HowToRegRounded,
    NfcRounded,
    PeopleRounded,
    NotificationsRounded,
    FactoryRounded,
    LocalShippingRounded
} from "@mui/icons-material";

interface ShowroomComponentProps { }

const ShowroomComponent: FC<ShowroomComponentProps> = () => {
    const navigate = useNavigate();
    const { state } = useGlobalState();
    const user = useUser();

    const logoutHandler = async () => {
        const confirm = window.confirm('Czy na pewno chcesz się wylogować?');
        if (!confirm) return;
        await user.logout();
        navigate('/');
    };

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    const names = ['Warszawa', 'Mińsk Mazowiecki', 'Piaseczno'];
    const [idx, setIdx] = useState(0);
    useEffect(() => {
        const id = setInterval(() => setIdx(v => (v + 1) % names.length), 2000);
        return () => clearInterval(id);
    }, [names.length]);


    return (
        <>
            <div className={styles.selectShowroomContainer}>
                <div >
                    <div className={styles.selectedShowroom}>
                        <span key={idx} className={styles.slideIn}>{names[idx]}</span>
                    </div>
                </div>
            </div>

            {state.currentUser && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%', mr: 17 }}>
                    <Card
                        className={styles.adminDiv}
                        elevation={0}
                        sx={{
                            flex: '0 0 auto',
                            px: 2,
                            py: 1.25,
                            borderRadius: 2,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: 2,
                            border: '1px solid rgba(34,48,131,0.12)',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                            backgroundColor: '#fff'
                        }}
                    >
                        <Stack direction="row" alignItems="center" spacing={1.25} className={styles.loggedIn}>
                            <AdminPanelSettingsRounded sx={{ color: '#223083' }} fontSize="small" />
                            <Typography variant="body2" sx={{ fontWeight: 700, color: 'text.primary' }}>
                                {state.currentUser?.displayName || state.currentUser?.username}
                            </Typography>
                        </Stack>

                        {state.currentUser && (
                            <>
                                <Button
                                    variant="outlined"
                                    onClick={handleMenuClick}
                                    startIcon={<SettingsRounded />}
                                    sx={{
                                        borderRadius: 10,
                                        px: 2,
                                        fontWeight: 700,
                                        textTransform: 'uppercase',
                                        letterSpacing: '.06em',
                                        borderColor: 'rgba(47,62,164,0.35)',
                                        color: '#223083',
                                        '&:hover': {
                                            borderColor: 'rgba(47,62,164,0.6)',
                                            backgroundColor: 'rgba(47,62,164,0.06)'
                                        }
                                    }}
                                >
                                    Opcje
                                </Button>
                                <Menu
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleMenuClose}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                    MenuListProps={{ dense: true }}
                                >
                                    <Can permission="admin.access"><MenuItem onClick={() => { handleMenuClose(); navigate('/adminPanel'); }}>
                                        <DashboardRounded fontSize="small" style={{ marginRight: 8 }} />
                                        Panel Admina
                                    </MenuItem></Can>
                                    <Can permission="users.read"><MenuItem onClick={() => { handleMenuClose(); navigate('/admin/uzytkownicy'); }}>
                                        <PeopleRounded fontSize="small" style={{ marginRight: 8 }} />
                                        Uzytkownicy
                                    </MenuItem></Can>
                                    <Can permission="notifications.read"><MenuItem onClick={() => { handleMenuClose(); navigate('/admin/powiadomienia'); }}>
                                        <NotificationsRounded fontSize="small" style={{ marginRight: 8 }} />
                                        Powiadomienia
                                    </MenuItem></Can>
                                    <Can permission="nonWorkingDays.read"><MenuItem onClick={() => { handleMenuClose(); navigate('/admin/wolneFabryk'); }}>
                                        <FactoryRounded fontSize="small" style={{ marginRight: 8 }} />
                                        Wolne fabryk
                                    </MenuItem></Can>
                                    <Can permission="deliveryNotices.read"><MenuItem onClick={() => { handleMenuClose(); navigate('/admin/awizacjeDostaw'); }}>
                                        <LocalShippingRounded fontSize="small" style={{ marginRight: 8 }} />
                                        Awizacje dostaw
                                    </MenuItem></Can>
                                    <Can permission="invoices.read"><MenuItem onClick={() => { handleMenuClose(); navigate('/proformy'); }}>
                                        <ReceiptLongRounded fontSize="small" style={{ marginRight: 8 }} />
                                        Panel Proform
                                    </MenuItem></Can>
                                    <Can permission="timeTracking.read"><MenuItem onClick={() => { handleMenuClose(); navigate('/skanowanieObecnosci'); }}>
                                        <HowToRegRounded fontSize="small" style={{ marginRight: 8 }} />
                                        Skanowanie obecności
                                    </MenuItem></Can>
                                    <Can permission="employees.read"><MenuItem onClick={() => { handleMenuClose(); navigate('/pracownicy'); }}>
                                        <PeopleRounded fontSize="small" style={{ marginRight: 8 }} />
                                        Pracownicy
                                    </MenuItem></Can>
                                    <Can permission="rfid.read"><MenuItem onClick={() => { handleMenuClose(); navigate('/rfid'); }}>
                                        <NfcRounded fontSize="small" style={{ marginRight: 8 }} />
                                        RFID
                                    </MenuItem></Can>
                                    <MenuItem onClick={() => { handleMenuClose(); logoutHandler(); }}>
                                        <LogoutRounded fontSize="small" style={{ marginRight: 8 }} />
                                        Wyloguj
                                    </MenuItem>
                                </Menu>
                            </>
                        )}
                    </Card>
                </Box>
            )}

            {!state.currentUser && !state.isAuth && state.isAuthInvoice && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                    <Card
                        className={styles.adminDiv}
                        elevation={0}
                        sx={{
                            flex: '0 0 auto',
                            px: 2,
                            py: 1.25,
                            borderRadius: 2,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            gap: 2,
                            border: '1px solid rgba(34,48,131,0.12)',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                            backgroundColor: '#fff'
                        }}
                    >
                        <Button
                            variant="contained"
                            onClick={() => navigate('/proformy')}
                            startIcon={<ReceiptLongRounded />}
                            sx={{
                                borderRadius: 10,
                                px: 2,
                                fontWeight: 700,
                                textTransform: 'uppercase',
                                letterSpacing: '.06em',
                                color: '#fff',
                                backgroundImage:
                                    'linear-gradient(180deg, #2f3ea4 0%, #293a98 40%, #26358f 70%, #223083 100%)',
                                boxShadow: '0 6px 14px rgba(34,48,131,0.25)',
                                '&:hover': {
                                    filter: 'brightness(1.02)',
                                    boxShadow: '0 8px 16px rgba(34,48,131,0.35)'
                                }
                            }}
                        >
                            Panel Proform
                        </Button>
                    </Card>
                </Box>
            )}
        </>
    );
};

export default ShowroomComponent;
